/**
 * Application Constants
 *
 * Shared constants used across multiple files.
 * Single-use constants should remain in their respective files.
 */

/**
 * Map and Visualization Constants
 *
 * Used by: elevation_map_controller.ts, geoapify_map_service.ts
 */
export const MAP_CONSTANTS = {
  // Default colors for polygons and markers
  DEFAULT_FILL_COLOR: '#FF0000',
  DEFAULT_STROKE_COLOR: '#FF0000',

  // Elevation visualization colors (gradient from deep blue to light cyan)
  ELEVATION_COLORS: [
    '#0066CC', // Deep blue (lowest)
    '#0099FF',
    '#33CCFF',
    '#66DDFF',
    '#99EEFF',
    '#CCFFFF'  // Light cyan (highest)
  ],
  DEFAULT_ELEVATION_COLOR: '#0066CC',

  // Contour line colors (blue to green gradient for elevation ranges)
  CONTOUR_LINE_COLORS: [
    '#0066CC', '#0099FF', '#33CCFF', '#66DDFF',
    '#99EEFF', '#CCFFFF', '#CCFFCC', '#99FF99',
    '#66FF66', '#33FF33', '#00FF00', '#00CC00'
  ],

  // Grid system
  GRID_MIN: 1,
  GRID_MAX: 20,
  GRID_SIZE: 20
} as const
